module.exports = __webpack_public_path__ + "7bc838b099d601afc5b88a78144344bd.png";